<template>
  <div class="ion-page">
    <ion-header>
      <ion-toolbar>
        <ion-title>Other Patients</ion-title>
        <ion-buttons slot="start">
          <ion-back-button href="/"></ion-back-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content class="ion-padding">
      <ion-list v-if="otherPatients.length > 0">
        <ion-item text-center v-for="otherPatient in otherPatients" :key="otherPatient.Id">
          <ion-label>
            <ion-button
              style="width: 90%;"
              class="adjust-font-size"
              @click="
                goToScreenTwo(
                  otherPatient.patientWebId + '~' +
                  otherPatient.patientName + '~' + otherPatient.patientLocation
                  + '~' + otherPatient.id
                )
              "
            >{{ otherPatient.patientName }}</ion-button>
          </ion-label>
        </ion-item>
      </ion-list>
    </ion-content>
  </div>
</template>
<script>
import Repository from "../../repositories/RepositoryFactory";
const FamilyAccountRepository = Repository.get("familyaccount");
export default {
  name: "adminmainpage",
  model: "",
  appointmentDate: "",
  data() {
    return {
      openAppointments: [],
      otherPatients: [],
      appointmentDate: ""
    };
  },
  created: async function() {
    const addFamilyAccountResult = await FamilyAccountRepository.getFamilyAccounts(
      this.$store.state.userId
    );
    this.otherPatients = addFamilyAccountResult.data;

    // eslint-disable-next-line no-console
    console.log(addFamilyAccountResult.data);
  },
  methods: {
    goToScreenTwo(result) {
      let self = this;

      self.$router.push({
        name: "otherpatientsscreentwo",
        params: { data: result  },
      });
      //self.$router.push({ name: "otherpatientsscreentwo" });
    }
  }
};
</script>
